// services/http.interceptor.js
import axios from 'axios'

const apiClient = axios.create({
  baseURL: 'https://mns.gelogs.co.th/api/',
  headers: {
    'Content-Type': 'application/json',
  },
})

apiClient.interceptors.request.use(
  config => {
    const token = localStorage.getItem('accessToken')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error),
)

export default apiClient
